import React from "react";
import { createClasses } from "@bloomberg/media-ui-core";
import { Change, Variant } from "@bloomberg/media-ui-markets";
import styles from "./styles.module.css";
import { isTickerUp } from "~utils/portfolio/tickerUtils";
import type { MarketValueChange } from "~types/portfolio";

type FormatterFunction =
  | ((
      number: string | number,
      currency?: string,
      dp?: number
    ) => string | number)
  | ((priceChange: number, currency?: string, type?: string) => string);

type SummaryCellProps = {
  title: string;
  value: MarketValueChange;
  currency?: string;
  variant?: "with-change" | "value";
  formatter: FormatterFunction;
};

export default function SummaryCell(props: SummaryCellProps) {
  const { title, value, currency, variant = "value", formatter } = props;

  return (
    <div
      className={createClasses(styles.summaryCell, {
        [styles.withChange]: variant === "with-change",
      })}
    >
      <div className={styles.title}>
        {title}
        {currency && <div className={styles.currency}>({currency})</div>}
      </div>
      <div className={styles.valueContainer}>
        <span className={styles.value}>{formatter(value.value)}</span>
        {variant === "with-change" && (
          <Change
            className={styles.change}
            percentChange={value.pctChange || 0}
            variant={Variant.refresh2024}
          />
        )}
      </div>
    </div>
  );
}
